module.exports = __webpack_public_path__ + "static/media/20160201_191628.0c12f126.jpg";